import React, { useCallback, useEffect } from 'react';
import { DropdownButton } from 'react-bootstrap'
import Picker from 'emoji-picker-react';
import { Grid } from '@mui/material';

const Emoji = props => {

  const getData = useCallback(() => {
    fetch('./emojis.json'
      , {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (myJson) {
        props.setEmojiData(myJson)
      });
  }, [props])

  useEffect(() => {
    getData()
    // eslint-disable-next-line
  }, [])

  const onEmojiClick = (event, emojiObject) => {
    props.setNewMessage(props.newMessage + emojiObject.emoji)
  };

  return (
    <Grid container sx={{ backgroundColor: 'transparent' }}>
      <DropdownButton
        key="up"
        drop="up"
        /*
          `secondary` é o cinza CHEIO do bootstrap, e fazia deste o botão
          mais pesado do compositor -- mais que enviar. Contornado, ele volta
          a ser o que é: um atalho ao lado dos outros.
        */
        variant="outline-secondary"
        title={'Emojis'}
        style={{ alignSelf: 'center', margin: "1%" }}
      >
        {/* {emojiOpen
        ?
        <Grid item sx={{inset: 'auto auto 2rem 0px', position: 'absolute' }}>
          <Grid >
            <Picker onEmojiClick={onEmojiClick}
              groupNames={{
                smileys_people: 'Caras amarelas',
                animals_nature: 'Animais e árvores',
                food_drink: 'Milkshakes e outros',
                travel_places: 'Viagens',
                activities: 'Atividades',
                objects: 'Objetos',
                symbols: 'Outros',
                flags: 'Bandeiras',
                recently_used: 'Mais usados',
              }}
              // pickerStyle={{ width: "100%"}}
              disableSearchBar
            />
          </Grid>
          <Grid sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center'
          }}>
            <IconButton onClick={handleEmojiOpen} >
              <MoodSharp />
            </IconButton>
          </Grid>
        </Grid>
        : <IconButton onClick={handleEmojiOpen}> <MoodSharp /> </IconButton>
      } */}
        <Picker onEmojiClick={onEmojiClick}
          groupNames={{
            smileys_people: 'Caras amarelas',
            animals_nature: 'Animais e árvores',
            food_drink: 'Milkshakes e outros',
            travel_places: 'Viagens',
            activities: 'Atividades',
            objects: 'Objetos',
            symbols: 'Outros',
            flags: 'Bandeiras',
            recently_used: 'Mais usados',
          }}
          pickerStyle={{
            // width: "100%",
            position: 'fixed',
            bottom: '2.8rem',
            // left: '53rem'
          }}
          disableSearchBar
        />
      </DropdownButton>
    </Grid>
  )
}

Emoji.propTypes = {}

export default Emoji